import StyledIllustration from "./StyledIllustration";
import React from "react";

export const VideoQuizIllustration = (
    <StyledIllustration
        className="kms-ds-video-quiz-illustration"
        fileName="video-quiz.svg"
        xmlns="http://www.w3.org/2000/svg"
        width="300"
        height="300"
        fill="none"
        viewBox="0 0 300 300"
    >
        <rect
            x="95"
            y="82.1748"
            width="47"
            height="23"
            rx="11.5"
            transform="rotate(-10.0165 95 82.1748)"
            className="Tone1"
            fill="#333333"
        />
        <circle
            cx="109.31"
            cy="91.3254"
            r="2.5"
            transform="rotate(-10.0165 109.31 91.3254)"
            className="Tone8"
            fill="white"
        />
        <circle
            cx="120.142"
            cy="89.4121"
            r="2.5"
            transform="rotate(-10.0165 120.142 89.4121)"
            className="Tone8"
            fill="white"
        />
        <circle
            cx="130.974"
            cy="87.4989"
            r="2.5"
            transform="rotate(-10.0165 130.974 87.4989)"
            className="Tone8"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M58.6001 131.101C57.7164 123.976 62.776 117.484 69.9012 116.6C77.0263 115.716 83.5187 120.776 84.4024 127.901C85.2861 135.026 80.2264 141.519 73.1013 142.402C65.9762 143.286 59.4838 138.226 58.6001 131.101Z"
            className="Tone1"
            fill="#333333"
        />
        <path
            d="M67.1547 135.079L75.8478 123.924"
            className="sTone8"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path
            d="M77.0785 133.848L65.9237 125.155"
            className="sTone8"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <rect
            x="96.9014"
            y="120.188"
            width="109"
            height="124"
            rx="8"
            transform="rotate(-8 96.9014 120.188)"
            className="Primary"
            fill="#006EFA"
        />
        <rect
            x="134.066"
            y="133.142"
            width="61"
            height="10"
            rx="5"
            transform="rotate(-8 134.066 133.142)"
            className="Tone8"
            fill="white"
        />
        <rect
            x="137.685"
            y="158.889"
            width="61"
            height="10"
            rx="5"
            transform="rotate(-8 137.685 158.889)"
            className="Tone1"
            fill="#333333"
        />
        <rect
            x="141.303"
            y="184.636"
            width="61"
            height="10"
            rx="5"
            transform="rotate(-8 141.303 184.636)"
            className="Tone8"
            fill="white"
        />
        <rect
            x="144.921"
            y="210.383"
            width="61"
            height="10"
            rx="5"
            transform="rotate(-8 144.921 210.383)"
            className="Tone8"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M109.662 167.877C108.74 161.314 113.312 155.246 119.875 154.323C126.438 153.401 132.506 157.973 133.429 164.536C134.351 171.099 129.778 177.167 123.216 178.09C116.653 179.012 110.585 174.439 109.662 167.877Z"
            className="Tone1"
            fill="#333333"
        />
        <path
            d="M115.71 167.793L120.444 171.41L126.931 161.41"
            className="sTone8"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="113.409"
            y="137.055"
            width="8"
            height="8"
            rx="4"
            transform="rotate(-8 113.409 137.055)"
            className="sTone8"
            stroke="white"
            strokeWidth="2"
        />
        <rect
            x="120.647"
            y="188.549"
            width="8"
            height="8"
            rx="4"
            transform="rotate(-8 120.647 188.549)"
            className="sTone8"
            stroke="white"
            strokeWidth="2"
        />
        <rect
            x="124.265"
            y="214.296"
            width="8"
            height="8"
            rx="4"
            transform="rotate(-8 124.265 214.296)"
            className="sTone8"
            stroke="white"
            strokeWidth="2"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M152.985 57.3011C151.765 55.1337 153.56 52.5079 156.023 52.8591L188.959 57.5571C191.826 57.9661 192.507 61.7987 189.956 63.1697L178.836 69.1449C178.146 69.5158 177.628 70.142 177.394 70.8896L173.474 83.3854C172.688 85.8924 169.287 86.249 167.998 83.9596L152.985 57.3011Z"
            className="Primary"
            fill="#006EFA"
        />
        <path
            d="M226.05 174.397C228.006 174.031 249.26 169.725 257.562 151.91C267.565 130.444 252.744 107.847 245.703 107.847C242.073 107.847 240.85 111.01 242.747 113.794C247.92 121.384 263.206 113.492 270.1 105.113C281.476 91.284 277.052 59.0089 251.124 56.4922C225.197 53.9755 222.88 75.8936 197.5 77C182.841 77.6391 166.414 63.1775 166.414 63.1775"
            className="sTone1"
            stroke="#333333"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <rect
            x="25.1548"
            y="79.4148"
            width="48"
            height="35"
            rx="8"
            transform="rotate(-22.298 25.1548 79.4148)"
            className="Primary"
            fill="#006EFA"
        />
        <path
            d="M33.7417 84.54L52.8222 89.7223C53.7358 89.9705 54.7054 89.604 55.2265 88.8136L67.0497 70.8808"
            className="sTone8"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </StyledIllustration>
);
